import { RateServiceRouteService } from 'common/data';
import { BaseService } from 'core/services';
import _ from 'lodash';

class RateService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new RateServiceRouteService());
	}

	getRates = payload => {
		const url = this.routeService.getRates();
		return this.apiClient.post(url, payload);
	};

	getReturnRates = payload => {
		const url = this.routeService.getReturnRates();
		return this.apiClient.post(url, payload);
	};

	getRateCalculatorRates = payload => {
		const url = this.routeService.getRateCalculatorRates();
		return this.apiClient.post(url, payload);
	};

	getRateCalculatorBulkRates = payload => {
		const url = this.routeService.getRateCalculatorBulkRates();
		return this.apiClient.post(url, payload);
	};
}

export default RateService;



// WEBPACK FOOTER //
// ./src/common/data/services/RateService.js